module.exports = __webpack_public_path__ + "static/media/envelope-heart.61896fab.svg";